import { InfoAlert } from "./styles";
import closeIcon from "./imgs/close-icon.svg";
import headerImg from "./imgs/discover_pricesless_banner.webp";

const DiscoverPricelessModal = ({ serialNumber, onClose }) => {
  return (
    <InfoAlert>
      <div className="inner-container">
        <div className="img-container">
          <img src={headerImg} alt="header" />
          <h2>{"Discover Priceless"}</h2>
        </div>
        <div className="close-button" onClick={onClose}>
          <img src={closeIcon} alt="close" />
        </div>
        <div className="scroll-view">
          <div className="section">
            <p>{"Explore priceless experiences around the world."}</p>
            <p>
              {
                "From once-in-a-lifetime events to extraordinary dining and travel experiences, discover priceless experiences that Mastercard offers across the globe.​"
              }
            </p>
          </div>
          <div className="section bg-black">
            <p>{"Learn more on Priceless.com​"}</p>
            <div className="group btn-group">
              <div
                className="button"
                onClick={() => {
                  window.open(`https://www.priceless.com/`, "_blank");
                }}
              >
                <p>{"Visit Priceless"}</p>
              </div>
            </div>
            <video
              src={
                "https://s3.eu-west-2.amazonaws.com/www.digiseq.co.uk/mastercard/BD_MC_Europe_Priceless_Hero_16x9.mp4"
              }
              playsInline
              preload="auto"
              controls
            />
          </div>
        </div>
      </div>
    </InfoAlert>
  );
};

export default DiscoverPricelessModal;
